// extracted by mini-css-extract-plugin
export default {"container":"Notepad_container__+3csl","barContainer":"Notepad_barContainer__3ZO5V"};